<template>
  <div
    class="order-row d-flex align-items-center"
    :class="{ changed }"
  >
    <div class="flex-grow-1 pr-2">
      <div
        class="name"
        :class="{ crossed }"
      >
        {{ name }}
      </div>
      <div
        v-if="price"
        class="price"
      >
        {{ price }}
      </div>
    </div>
    <CountStepper
      :value="value || 0"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import CountStepper from './CountStepper';

export default {
  props: {
    value: Number,
    name: String,
    price: String,
    crossed: Boolean,
    changed: Boolean,
  },
  components: {
    CountStepper,
  },
};
</script>

<style lang="scss" scoped>
.order-row {
  background-color: white;
  border: 1px dashed transparent;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;

  &.changed {
    border-color: $blue;
  }
}

.name {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;

  &.crossed {
    text-decoration: line-through;
  }
}

.price {
  font-family: "DM-Mono", monospace;
  font-size: 14px;
}
</style>
